// Webpack Imports
import * as bootstrap from 'bootstrap';


(function($) {
	$(document).ready(function () {
		
			$('.c-card .vce-text-block .vce-text-block-wrapper').matchHeight();
			$('.c-card .vce-text-block .vce-text-block-wrapper h2').matchHeight();
			$('.c-card .vce-text-block .vce-text-block-wrapper h3').matchHeight();

		$(window).on('resize', function() {

			$('.c-card .vce-text-block .vce-text-block-wrapper').matchHeight();
			$('.c-card .vce-text-block .vce-text-block-wrapper h2').matchHeight();
			$('.c-card .vce-text-block .vce-text-block-wrapper h3').matchHeight();
	
		});

		$.fn.isInViewport = function() {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
		
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
		
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};
		// menu mobile 
		
		$( ".c-sub-header_burger-icon" ).click(function() {
			$( ".c-header" ).addClass("show-menu-mobile");
			$( ".c-header_backdrop" ).addClass("show_backdrop");
			
		});

		$( ".c-header_close-menu-icon" ).click(function() {
			$( ".c-header").removeClass("show-menu-mobile");
			$( ".c-header_backdrop" ).removeClass("show_backdrop");
		});

		$( ".c-header_backdrop" ).click(function() {
			$( ".c-header").removeClass("show-menu-mobile");
			$( ".c-header_backdrop" ).removeClass("show_backdrop");
		});
		


	});
})(jQuery);


(function($) {
	$(document).ready(function () {
		
		//$('.current-page-ancestor > .sub-menu').addClass("u-menu-active")
		//$('.current-page-ancestor > .menu-toggel').addClass("menu-toggel-active")

		//$('.current-menu-parent > .sub-menu').addClass("u-menu-active")
		//$('.current-menu-parent > .menu-toggel').addClass("menu-toggel-active")

		//$('.current-menu-item  > .sub-menu').addClass("u-menu-active")
		//$('.current-menu-item  > .menu-toggel').addClass("menu-toggel-active")

		$( '.c-header #navbar >ul > .menu-item > .menu-toggel' ).click(function() {
			
			if($(this).hasClass("menu-toggel-active")) {
				var $menuToggel = 'true';
			}

			else {
				var $menuToggel = 'false';
			}
			
			$( '.c-header #navbar >ul > .menu-item > .menu-toggel' ).each(function() {
			
				$(this).removeClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").removeClass("u-menu-active");

			});
			
			if ($menuToggel == 'false') {
				$(this).addClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").addClass("u-menu-active");
			}
			
		});

		$( '.c-header #navbar >ul > .menu-item > .sub-menu > .menu-item > .menu-toggel' ).click(function() {
			
			

			//$(this).toggleClass( "menu-toggel-active" );
		
			//$(this).next(".sub-menu").toggleClass("u-menu-active");
            if($(this).hasClass("menu-toggel-active")) {
				var $menuToggel = 'true';
			}

			else {
				var $menuToggel = 'false';
			}

			$( '.c-header #navbar >ul > .menu-item > .sub-menu > .menu-item > .menu-toggel').each(function() {
				
				$(this).removeClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").removeClass("u-menu-active");
				
			});
		
		    if ($menuToggel == 'false') {
				$(this).addClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").addClass("u-menu-active");
			}


		});

		window.addEventListener('click', function(e){   
			if (document.getElementById('c-header').contains(e.target)){
				
			} else{
				
				$("#menu-main-menu > .menu-item-has-children  > .menu-toggel").each(function() {
					
					$(this).removeClass( "menu-toggel-active" );
					$(this).next(".sub-menu").removeClass("u-menu-active");
				});	
			}
		});


		$( '.c-header #navbar >ul > .menu-item-has-children' ).hover(function() {
			console.log('1');
			if($(this).children(".menu-toggel").hasClass("menu-toggel-active")) {
				var $menuToggel = 'true';
			}

			else {
				var $menuToggel = 'false';
			}
			
			$( '.c-header #navbar >ul > .menu-item > .menu-toggel' ).each(function() {
			
				$(this).removeClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").removeClass("u-menu-active");

			});
			
			if ($menuToggel == 'false') {
				$(this).children(".menu-toggel").addClass( "menu-toggel-active" );
			
				$(this).children(".sub-menu").addClass("u-menu-active");
			}
			
		});
/*
		$( '.c-header #navbar >ul > .menu-item > .sub-menu > .menu-item' ).hover(function() {
			console.log('2');
			if($(this).children(".menu-toggel").hasClass("menu-toggel-active")) {
				var $menuToggel = 'true';
			}

			else {
				var $menuToggel = 'false';
			}
			
			$( '.c-header #navbar >ul > .menu-item > .sub-menu > .menu-item' ).each(function() {
			
				$(this).removeClass( "menu-toggel-active" );
			
				$(this).next(".sub-menu").removeClass("u-menu-active");

			});
			
			if ($menuToggel == 'false') {
				$(this).children(".menu-toggel").addClass( "menu-toggel-active" );
			
				$(this).children(".sub-menu").addClass("u-menu-active");
			}
			
		});
*/
	
	});
	
})(jQuery);


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();